module.exports = __webpack_public_path__ + "img/agent.401029d7.png";